module.exports = __webpack_public_path__ + "static/media/MyT-Square.950a265d.svg";